import { render } from "./CrossSellResultsLNG.vue?vue&type=template&id=9dea3156&scoped=true"
import script from "./CrossSellResultsLNG.vue?vue&type=script&lang=js"
export * from "./CrossSellResultsLNG.vue?vue&type=script&lang=js"

import "./CrossSellResultsLNG.vue?vue&type=style&index=0&id=9dea3156&lang=scss"
import "./CrossSellResultsLNG.vue?vue&type=style&index=1&id=9dea3156&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dea3156"]])

export default __exports__